import { CompetitionBySportV2Schema } from '@/views/sports/CompetitionsBySport/styles/CompetitionBySportV2.styles';

export const competitionBySportV2Styles: CompetitionBySportV2Schema = {
  containerNav: { mb: '2' },
  scrollButtonGroup: {
    mb: '2',
    variant: 'filter',
    bg: 'rgba(255, 138, 47, 1)',
    boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  scrollButtonGroupDivider: {
    mb: '2',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
    borderColor: 'blackAlpha.400',
  },
  competitionListBoxWrapper: {
    w: 'full',
  },
};
